<template>
  <div class="uniform">
    <div v-if="checkList.length != 0">
      <div class="order" v-if="addressList.length != 0">
        <div class="flex location">
          <van-icon name="location-o" class="mt-3" />
          <div class="flex1 ml-5">
            <div class="font14 color3">{{addressList[0].address}}</div>
            <div class="font12 color6 mt-5">{{getChildName(addressList[0].child_id)}}</div>
          </div>
          <span class="font14 more" v-if='addressList.length > 1' @click="showLocation">{{ $t("uniform.num_Pickup_Locations", { x: addressList.length }) }} <van-icon name="arrow" /></span>
        </div>
      </div>
      <div v-if="orderData.length != 0">
        <div class="order" v-for="(list, i) in orderData" :key="i">
          <div class="flex align">
            <div class="color3 font12 flex1">{{ $t("uniform.Order_NO") }}：{{ list.order_id }}</div>
            <div class="color6 font12">{{ list.order_date }}</div>
          </div>
          <van-divider />
          <div class="mb-20" v-for="(item, index) in list.children" :key="index">
            <div class="flex" @click="router(list)">
              <span class="relative">
                <img :src="item.img" class="img72 mr-10" />
                <span class="labelSuit" v-if="item.bundle_items && item.bundle_items.length > 0">{{$t("uniform.Set")}}</span>
              </span>
              <div class="item-1-1 flex1">
                <div class="name">{{ item.title }}</div>
                <div class="sub-name pt-3" v-if="item.bundle_items && item.bundle_items.length > 0">{{ item.exchange_flag ? (item.exchange_detail ? item.exchange_detail.original_attr.attr2 : item.attr2) : item.attr2 }} / {{ $t("uniform.bundle_items_count", { x: getBundleNum(item.bundle_items) }) }}</div>
                <div class="sub-name pt-3" v-else>{{ item.exchange_flag ? (item.exchange_detail ? item.exchange_detail.original_attr.attr1 : item.attr1) : item.attr1 }} / {{ item.exchange_flag ? (item.exchange_detail ? item.exchange_detail.original_attr.attr2 : item.attr2) : item.attr2 }}</div>
                <div class="flex mt-10">
                  <div class="flex1 name">¥ {{ item.unit_price }}</div>
                  <div class="color6 font12">x{{ item.num }}</div>
                </div>
                <!-- <div class="uniformStatus" v-if="item.is_bundle_main == 0">
                  <div class="font12 flex align color3" v-if="item.exchange_flag">
                    <span :class="[getExchangeClass(item), 'ml-5']">{{ getExchangeText(item) }}</span>
                    <div class="color6 font12 ml-10" v-if="[1, 2].includes(item.exchange_flag) && item.exchange_detail">更换为：{{ item.exchange_detail.exchange_attr.attr2 }}</div>
                  </div>
                  <div class="font12 flex align color3" :class="getStatusClass(item)" v-else-if="item.status">
                    <van-icon :name="getStatusIcon(item)" size="14" />
                    <span class="flex1 ml-5">{{ getStatusText(item) }}</span>
                    <div class="color6 font12 ml-10" v-if="[41, 45, 50].includes(item.status)">退款¥{{ item.refund_amount }}</div>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- <div class="suitDetails" v-if="item.bundle_items && item.bundle_items.length > 0">
              <div class="flex align-items pb-12" v-for="(bundleItem, index) in item.bundle_items" :key="index">
                <img :src="bundleItem.img" alt="" class="img44" />
                <div class="ml-8 flex1">
                  <div class="color3 font14">{{ bundleItem.title }}</div>
                  <div class="color6 font11 mt-5">{{ bundleItem.exchange_flag ? bundleItem.exchange_detail.original_attr.attr1 : bundleItem.attr1 }} / {{ bundleItem.exchange_flag ? bundleItem.exchange_detail.original_attr.attr2 : bundleItem.attr2 }}</div>
                </div>
                <div class="font12" :class="getExchangeClass(bundleItem)" v-if="bundleItem.exchange_flag">{{ getExchangeText(bundleItem) }}</div>
                <div class="font12" :class="getStatusClass(bundleItem)" v-else>{{ getStatusText(bundleItem) }}</div>
                <div class="color6 font12 ml-10" v-if="[41, 45, 50].includes(bundleItem.status)">退款¥{{ bundleItem.refund_amount }}</div>
                <div class="color6 font12 ml-10" v-if="[1, 2].includes(bundleItem.exchange_flag)">更换为：{{ bundleItem.exchange_detail.exchange_attr.attr2 }}</div>
              </div>
            </div> -->
          </div>
          <van-divider />
          <div class="text-right">
            <span class="font12 color6 mr-15"> {{ $t("uniform.Subtotal", { x: list.product_count }) }} </span> <span class="font12 color6">{{ $t("uniform.Total") }}</span> <span class="color3 font12 fontWeight">¥ </span><span class="font16 color3">{{ list.order_amount }}</span>
          </div>
          <!-- <div class="flex align">
            
            <div v-if="schoolType != 'BJ_DS' && schoolType != 'BJ_QFF' && schoolType != 'BJ_SLT'">
              <van-button type="default" round size="small" @click="cancelOrder(list)" v-if="showBtn(list)"> {{ $t("uniform.Cancel_order") }}</van-button>
            </div>
          </div> -->
        </div>
      </div>
      <div v-else>
        <van-empty :description="$t('calendar.no_data')" image="https://m2.files.ivykids.cn/cloud01-file-8025768Fpkv74gsyXNIWDf0HfWgAyaI0Smi.png" />
      </div>
    </div>
    <van-action-sheet v-model="show" :title="$t('uniform.Cancel_order')">
      <div class="content" v-if="cancelData.children">
        <div v-if="!isNext">
          <div class="flex mb-20" v-for="(item, index) in cancelData.children" :key="index">
            <van-checkbox v-if="item.disabled" :disabled="item.disabled"><img :src="item.img" alt="" class="img72 mr-10" /></van-checkbox>
            <van-checkbox v-model="item.checked" v-else>
              <img :src="item.img" alt="" class="img72 mr-10" />
            </van-checkbox>
            <div class="item-1-1 flex1">
              <div class="name">{{ item.title }}</div>
              <div class="sub-name pt-3">{{ item.attr1 }} ｜ {{ item.attr2 }}</div>
              <div class="flex mt-10">
                <div class="flex1 name">¥ {{ item.unit_price }}</div>
                <div class="color6 font14">× {{ item.num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <van-radio-group v-model="options">
            <van-cell-group>
              <van-cell v-for="(item, index) in checkList" clickable :key="index" :title="item.title" class="padding">
                <template #right-icon>
                  <van-radio :name="item.id" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <div class="mt-10 mb-10 color3 font14">{{ $t("notice.memo") }}</div>
          <van-field v-model="reason" rows="2" autosize type="textarea" class="textareaVal" :placeholder="$t('notice.please_memo')" show-word-limit />
        </div>
        <van-goods-action>
          <van-goods-action-button v-if="!isNext" color="#4D88D2" type="warning" :text="$t('uniform.Next_Step')" @click="next()" />
          <van-goods-action-button v-else color="#4D88D2" type="warning" :text="$t('global.submit')" @click="clearOrder()" />
        </van-goods-action>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="locationShow" :title="$t('uniform.Pickup_Locations')">
      <div class="order">
        <div class="flex location mb-16" v-for="(list,index) in addressList" :key="index">
          <van-icon name="location-o" class="mt-3" />
          <div class="flex1 ml-5">
            <div class="font14 color3">{{ list.address }}</div>
            <div class="font12 color6">{{ getChildName(list.child_id) }}</div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import storage from "store";
import Vue from "vue";
import { CURRENT_CHILD } from "@/store/mutation-types";
import i18n from "../i18n";
import { NoticeBar, ActionSheet, Empty, Toast, Icon, GoodsAction, GoodsActionIcon, GoodsActionButton, Sku, Divider, RadioGroup, Radio } from "vant";
import { orderList, clearOrderGoods } from "@/api/uniform";
import store from "../store";
import { childList } from "@/api/child";

// import { status } from "nprogress";
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Divider);
Vue.use(Sku);
Vue.use(RadioGroup);
Vue.use(Radio);
export default {
  name: "uniform",

  data() {
    return {
      orderData: {},
      cancelData: {},
      show: false,
      checked: [],
      child_id: "",
      childData: {},
      isNext: false,
      checkList: [],
      options: [],
      reason: "",
      schoolType: "",
      locationShow:false,
      addressList:[],
      childList:[]
    };
  },
  beforeCreate() {
    // document.querySelector("body").setAttribute("style", "background-color:#fff;");
  },
  mounted() {
    let schoolType = store.getters.wxState || "ds";
    document.title = schoolType == "ds" ? this.$t("router.uniform") : this.$t("router.Purchase");
  },
  created() {
    this.childData = storage.get(CURRENT_CHILD + i18n.locale);
    this.schoolType = this.childData.schoolid;
    this.child_id = this.childData.id;
    childList().then((res) => {
      this.childList = res.data;
      this.getList();
    })
  },
  methods: {
    // 获取状态文本
    getStatusText(item) {
      const statusMap = {
        10: "未付款",
        20: this.$t("uniform.waiting_confirmation"),
        30: this.$t("uniform.waiting_distribution"),
        40: this.$t("uniform.Completed"),
        41: this.$t("uniform.waiting_refund"),
        45: this.$t("uniform.Refunding"),
        50: this.$t("uniform.Refunded"),
        89: this.$t("uniform.Transaction_Expired"),
        99: this.$t("uniform.Cancelled"),
      };
      return statusMap[item.status] || "";
    },
    // 获取状态样式类
    getStatusClass(item) {
      const classMap = {
        10: "red",
        20: "orange",
        30: "blue",
        40: "green",
        41: "red",
        45: "red",
        50: "red",
        89: "red",
        99: "red",
      };
      return classMap[item.status] || "";
    },
    // 获取状态图标
    getStatusIcon(item) {
      const iconMap = {
        20: "question-o",
        30: "info-o",
        40: "passed",
        41: "warning-o",
        45: "warning-o",
        50: "warning-o",
        89: "warning-o",
        99: "warning-o",
      };
      return iconMap[item.status] || "";
    },
    getExchangeClass(item) {
      if (item.exchange_flag == 1) {
        return "red";
      }
      if (item.exchange_flag == 2) {
        return "green";
      }
      if (item.exchange_flag == 3) {
        return "";
      }
      return "";
    },
    // 换货状态文本
    getExchangeText(item) {
      const map = { 1: this.$t("uniform.Exchange"), 2: this.$t("uniform.Exchanged"), 3: this.$t("uniform.Exchange_Canceled") };
      return map[item.exchange_flag] || "";
    },
    showBtn(list) {
      if (list.children.findIndex((target) => target.status == 20) == -1) {
        return false;
      } else {
        return true;
      }
    },
    getList() {
      orderList({ child_id: this.child_id }).then((res) => {
        this.orderData = res.data.list;
        this.checkList = res.data.refund_reason;
        this.addressList = res.data.address;
      });
    },
    getChildName(child_id){
      let child = this.childList.find((item) => item.id == child_id);
      return child.name || "";
    },
    cancelOrder(list) {
      list.children.forEach((item) => {
        this.$set(item, "checked", false);
        item.disabled = true;
        if (item.status == 20) {
          item.disabled = false;
        }
      });
      this.cancelData = list;
      this.isNext = false;
      this.show = true;
    },
    next() {
      let checked = this.cancelData.children.filter((item) => item.checked);
      if (checked.length == 0) {
        return;
      }
      this.isNext = true;
    },
    clearOrder() {
      let checked = this.cancelData.children
        .filter((item) => item.checked)
        .map((_item) => {
          return _item.id;
        });
      clearOrderGoods({ ids: checked, reason: this.reason, options: this.options }).then(() => {
        this.show = false;
        this.getList();
        Toast.success(this.$t("ptc.successful"));
      });
    },

    router(item) {
      this.$router.push({
        path: "OrderDetail/" + item.order_id,
      });
    },
    getBundleNum(bundleItems) {
      return bundleItems.length;
    },
    showLocation(){
      this.locationShow=true
    }
  },
};
</script>

<style scoped lang="less">
.uniform {
  overflow-y: scroll;
  height: 100vh;
}
.uniform::-webkit-scrollbar {
  display: none;
}
.child {
  padding: 13px 16px;
  background: #fff;
  align-items: center;
}
.order {
  background: #ffffff;
  border-radius: 8px;
  margin: 12px 8px;
  padding: 16px;

  .text-right {
    text-align: right;
  }
}
.img72 {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  object-fit: cover;
}
.name {
  font-size: 14px;
  color: #323233;
  font-weight: 500;
}
.sub-name {
  color: #646566;
  font-size: 12px;
}
.uniformStatus {
  padding: 6px 8px;
  background: #f7f8fa;
  border-radius: 4px;
  margin-top: 10px;
}
.orange {
  color: #ed6a0c;
}
.blue {
  color: #4d88d2;
}
.green {
  color: #45a367;
}
.red {
  color: #dc3838;
}
.align {
  align-items: center;
}
.content {
  padding: 16px;
  padding-bottom: 60px;
}
.textareaVal {
  background: #f7f8fa;
  border-radius: 8px;
}
.fontWeight {
  font-weight: 500;
}
.padding {
  padding: 10px 0;
}
.van-cell::after {
  left: 0;
  right: 0;
}
.relative {
  position: relative;
}
.labelSuit {
  width: 72px;
  height: 16px;
  position: absolute;
  left: 0;
  top: 56px;
  font-size: 12px;
  border-radius: 0 0 8px 8px;
  color: #fff;
  text-align: center;
  line-height: 16px;
  background: rgba(0, 0, 0, 0.5);
}
.suitDetails {
  padding: 12px 12px 0;
  background: #f7f8fa;
  border-radius: 8px;
  margin-top: 8px;

  .pb-12 {
    padding-bottom: 12px;
  }
  .img44 {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    object-fit: contain;
  }
  .font11 {
    font-size: 11px;
  }
}
.location {
  align-items: flex-start;
  .mt-3 {
    margin-top: 3px;
  }
  .more {
    color: #4d88d2;
  }
}
</style>
